module.exports = __webpack_public_path__ + "static/features-iphone-top-e3dfef0dd080c51aa5e03479c467ffa1.png";